import classNames from 'classnames'
import queryString from 'query-string'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Button } from '..'
import { Modal } from '../modal'
import { ModalHeader } from './modal-header'
import Background from './pages/bg.png'
import { Services } from './pages/services'
import { Sync } from './pages/sync'
import { Welcome } from './pages/welcome'

export function VezgoConnectionModal({
    link = false,
    onFinish = () => {},
    hide = false,
    finished,
    isLongPullingAccounts = false,
    setFinished,
}: {
    link?: boolean
    onFinish?: () => void
    hide: boolean
    finished: boolean
    isLongPullingAccounts: boolean
    setFinished: (finished: boolean) => void
}): JSX.Element {
    const [open, setOpen] = useState(false)
    let location = useLocation()

    const [index, setIndex] = useState(0)

    const { state, account } = useMemo(() => {
        return queryString.parse(location.search)
    }, [location])

    useEffect(() => {
        if (!finished && state && account && index !== 3) {
            setOpen(true)
            setIndex(3)
        }

        if (finished) {
            setOpen(false)

            if (index !== 0) {
                setIndex(0)
            }
        }
    }, [account, state, setIndex, index, finished])

    const onClickSync = useCallback(() => {
        setOpen(false)
        setIndex(0)
        onFinish()
        setFinished(true)
    }, [setOpen, setIndex, onFinish, setFinished])

    const pages = [
        <Welcome
            show={index === 0}
            onClick={() => {
                setIndex(1)
            }}
        />,
        <Services show={index === 1} />,
        <Sync
            show={index === 3}
            onClick={onClickSync}
            state={state}
            code={account}
            finished={finished}
        />,
    ]

    const modalStyles = classNames('h-screen w-screen fixed top-0 left-0')

    if (hide) return <></>
    return (
        <>
            {link || isLongPullingAccounts ? (
                <p
                    onClick={() => setOpen(!open)}
                    className={'text-linkYellow font-semibold cursor-pointer'}>
                    Link more accounts
                </p>
            ) : (
                <>
                    <Button
                        className={'h-16 w-64 overflow-hidden'}
                        onClick={() => setOpen(!open)}>
                        Open Vezgo
                    </Button>

                    <div className='mt-8 '>
                        <p className='text-black'>
                            Vezgo supports Binance, Kraken, Celsius etc.
                        </p>
                    </div>
                </>
            )}

            <Modal show={open} onClose={() => setOpen(false)}>
                <div
                    className={modalStyles}
                    onClick={event => event.stopPropagation()}>
                    <img
                        src={Background}
                        className={'absolute top-0 left-0 w-full h-full z-10'}
                        alt='bg'
                    />
                    <ModalHeader
                        onClose={() => setOpen(false)}
                        title='Link your Vezgo account'
                    />
                    <div className='relative z-20 w-full h-full'>{pages}</div>
                </div>
            </Modal>
        </>
    )
}
